import React from "react";

const Footer = () => {
  return (
    <footer
      style={{ height: "60px" }}
      className="w-100 fixed-bottom bg-dark d-flex justify-content-center align-items-center"
    >
      <h3 className="text-white fw-bold">Projekt zaliczeniowy PAW</h3>
    </footer>
  );
};
export default Footer;
